import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { useRef, useState } from 'react';
import { useSelector,useDispatch } from 'react-redux';
import {showmodal,ajoutsuccess,addOne} from './ChargementSlice';
import {Box, FormControl, InputLabel, LinearProgress, MenuItem, Select, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const Prechargement = () => {

    const userData = useSelector(state => state.userData);
    const ChargementData = useSelector(state => state.chargementsData);
    const showModal = ChargementData.showmodal;
    const ListPreVendeur = ChargementData.listPreVendeurs;

    const navigate = useNavigate();
    const dispatch= useDispatch();
    
    const [chargement,setChargement] = useState(false);
    const [valPreVendeurs, setvalPreVendeurs] = useState('');

    const dateChargementField = useRef('')

    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);

    const year = yesterday.getFullYear();
    const month = String(yesterday.getMonth() + 1).padStart(2, '0');
    const day = String(yesterday.getDate()).padStart(2, '0');

    const yesterdayDate = `${year}-${month}-${day}`;
  
    const [selectedDate, setSelectedDate] = useState(yesterdayDate);


        const handlePreVendeurChange = (event) => {
        setvalPreVendeurs(event.target.value);
        };

    const handleDateChange = (event) => {
      setSelectedDate(event.target.value);
    };

          const handleClose = () => {
        dispatch(showmodal(false));
      };
    
      const Ajouter =async()=>{

      if( valPreVendeurs==="" ){

            alert("Veuillez remplir les champs manquants");
            return
        }

        let valeur = ListPreVendeur.find(cat => cat._id === valPreVendeurs);
        const prevendeur = {
          id: valeur._id,
          nom: valeur.nom
        };

        const vendeur = valeur.vendeur


        const date = selectedDate

        setChargement(true)
        const apiUrl = process.env.REACT_APP_API_URL;
        const id = userData.id;
        const apitoken = userData.apitoken;


        try {
          const response = await axios.post(`${apiUrl}chargement/prevente/${id}/${apitoken}`, 
            
            {
              vendeur,
              prevendeur,
              date: selectedDate
            },
                {
                    timeout: 20000,
                  }
          );

          const reponse = response.data

          if(reponse.status==="charge no exist")

            alert("aucune prévente trouvée !")


            if(reponse.status==="already charged")

            alert("Ce prévendeur a déjà un chargement prévente pour cette date !")

          if(reponse.status==="stock error")

            alert(reponse.errors)

          if(reponse.status==="ok")

          {
            const _id=reponse.idchargement;
            const camion=reponse.camion;
            const date=reponse.date;
            const data={_id,vendeur,prevendeur,camion,date};
            dispatch(ajoutsuccess(true));
            dispatch(addOne(data));
            handleClose();
          }



    }

    catch (error){
      alert("Une erreur s'est produite lors de l'ajout du chargement prévente");
      }

      setChargement(false)

    }
    

  return (
    
    <Dialog open={showModal} onClose={() => dispatch(showmodal(false))}>

    { chargement ?
        <Box >
    <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
          <LinearProgress color="success" />
        </Stack>
        </Box>
                :
                ''
                }

        <DialogTitle>Nouveau chargement prévente</DialogTitle>

        <DialogContent>

              <TextField sx={{ marginTop: 2, width: '100%' }}
            inputRef={dateChargementField}
            value={selectedDate}
            onChange={handleDateChange}
            id="input-with-icon-textfield"
            label="Date prévente"
            size='normal'
            type='date'
        variant="outlined"
      />  


        <Box mt={2}>
          <FormControl fullWidth required>
          <InputLabel id="demo-simple-select-label">Prévendeur</InputLabel>
          <Select
          fullWidth
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={valPreVendeurs}
          label="Prévendeurs"
          onChange={handlePreVendeurChange}
        >
          {ListPreVendeur.map((item) => (
         <MenuItem key={item._id} value={item._id}>
           {item.nom}
         </MenuItem>
       ))}
          </Select>
          </FormControl>
          </Box>

        </DialogContent>

        <DialogActions>
            {chargement ?
            <>
          <Button disabled color="error" onClick={handleClose}>Annuler</Button>
          <Button disabled color="success" onClick={Ajouter}>Enregistrer</Button>
          </>
            :
            <>
          <Button color="error" onClick={handleClose}>Annuler</Button>
          <Button color="success" onClick={Ajouter}>Enregistrer</Button>
          </>
        }
        </DialogActions>

    </Dialog>    
  )
}

export default Prechargement